import { useContext } from 'react';
import './BlogPostEntry.css';
import { getDateStr, sanitizeStr } from './util';
import { LocaleContext } from './App';

export const BlogPostEntry = ({postData, onClick}) => {
    const locale = useContext(LocaleContext);

    return (
        <div className="blog_post_entry" onClick={onClick}>
            <div className="blog_post_entry_date text_small_2">{getDateStr(postData.date)}</div>

            <div className="blog_post_entry_headline text_2_black_bold">{postData.headline}</div>

            <div className="blog_post_entry_introduction_text text_2" dangerouslySetInnerHTML={{ __html: sanitizeStr(postData.introduction_text_html)}}></div>

            <div className="blog_post_entry_more_btn">
                <div className="text_small_small_semibold">{locale.msgs.READ_MORE}</div>
                <img src="/common/icon_more.svg"></img>
            </div>
        </div>
    );
}
